/* dl-hover2.js - second product photo on hover. 2026-08-22
 *
 * Adds ZERO bytes to a page load. The second photo's URL rides along in
 * data-hov on the card (written by snippets/dl-product-card.liquid and by the
 * four megamenu tile blocks in sections/dl-header-b.liquid); the image itself
 * is only downloaded the first time that card is hovered, decoded off-screen,
 * and inserted once it is ready - so the swap the visitor sees is instant and
 * never shows a half-painted photo.
 *
 * data-hov="" (empty) means "this product has no second photo" - the card is
 * marked done and nothing is fetched. A card with NO data-hov attribute at all
 * is the search takeover (.dls cards are built as a template string inside
 * dl-search.js from /search/suggest.json, which only carries one image). Those
 * fall back to a single cached /products/<handle>.js lookup per product.
 *
 * No Liquid on any template is required for this file to be safe: with the
 * attributes absent it degrades to the fetch path; with the script absent the
 * attributes are inert. Rollback = delete the dl-hover2.* tags from
 * snippets/dl-assets.liquid.
 */
(function () {
  'use strict';

  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var SEL = '.pcard, .navx-pcard';
  var jobs = Object.create(null); // product handle -> Promise<url|''>

  function box(card) {
    return card.querySelector('.th, .navx-th');
  }

  /* Insert the overlay only after the bytes are in and decoded. */
  function mount(card, url) {
    if (!url) return;
    var th = box(card);
    if (!th || th.querySelector('.dlh2')) return;
    var base = th.querySelector('img');
    if (!base) return;

    var img = new Image();
    img.className = 'dlh2';
    img.alt = '';
    img.decoding = 'async';
    img.onload = function () {
      if (!th.isConnected || th.querySelector('.dlh2')) return;
      /* Straight after the primary photo: the price chip and the badges are
         absolutely positioned later siblings and must stay on top. */
      base.insertAdjacentElement('afterend', img);
    };
    img.onerror = function () {};
    img.src = url;
  }

  function sized(u) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=600';
  }

  /* Search-takeover fallback. One request per product, ever, shared by every
     card that points at it. Failures resolve to '' and are cached too. */
  function lookup(card) {
    var href = card.getAttribute('href') || '';
    var m = href.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var handle = m[1];

    if (!jobs[handle]) {
      jobs[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          return p && p.images && p.images.length > 1 ? sized(p.images[1]) : '';
        })
        .catch(function () { return ''; });
    }

    jobs[handle].then(function (url) {
      card.setAttribute('data-hov', url);
      mount(card, url);
    });
  }

  /* One delegated listener for the whole document - megamenu rails are built
     and re-parented at runtime, so per-card binding would miss them. */
  document.addEventListener('pointerover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest(SEL);
    if (!card || card.getAttribute('data-h2') === '1') return;
    card.setAttribute('data-h2', '1');

    if (card.hasAttribute('data-hov')) mount(card, card.getAttribute('data-hov'));
    else lookup(card);
  }, true);

})();
